import plate from "../assets/Vectors/location.svg"
import clock from "../assets/Vectors/clock.svg";
import counter from "../assets/Vectors/counter.svg"

export const links = ["Home", "Blog", "About Us", "Contact"];

export const qna = [
  {
    id: 1,
    question: "What do I need to apply for the account?",
    ans: "Lorem ipsum dolor sit amet consectetur. Odio amet natoque tortor convallis. Bibendum sapien suspendisse ipsum urna malesuada elit. Bibendum vitae nibh scelerisque sed aliquam ullamcorper est. ",
  },
  {
    id: 2,
    question: "How the subscription process works?",
    ans: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga quae repellat obcaecati qui quam commodi!",
  },
  {
    id: 3,
    question: "What do I need to apply for the account?",
    ans: "Lorem ipsum dolor sit amet consectetur. Odio amet natoque tortor convallis. Bibendum sapien suspendisse ipsum urna malesuada elit. Bibendum vitae nibh scelerisque sed aliquam ullamcorper est. ",
  },
  {
    id: 4,
    question: "How the subscription process works?",
    ans: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga quae repellat obcaecati qui quam commodi!",
  },
  {
    id: 5,
    question: "What do I need to apply for the account?",
    ans: "Lorem ipsum dolor sit amet consectetur. Odio amet natoque tortor convallis. Bibendum sapien suspendisse ipsum urna malesuada elit. Bibendum vitae nibh scelerisque sed aliquam ullamcorper est. ",
  },
];

export const footerItems = [
  {
    header: "Quick links",
    links: ["Browse FoodTime", "Browse FoodTime", "Registration"],
  },
  {
    header: "About",
    links: ["About Us", "Mission", "Contact"],
  },
  {
    header: "Social",
    links: ["Facebook", "Twitter", "Instagram"],
  },
];

export const features = [
  {
    title : "Wide selection of restaurants",
    description : "Lorem ipsum dolor sit amet consectetur. Ornare massa nunc nibh tristique.",
    iconUrl : plate
  },
  {
    title : "Easy ordering process",
    description :"Lorem ipsum dolor sit amet consectetur. Ornare massa nunc .",
    iconUrl : counter
  },
  {
    title : "Fast delivery within 20 minutes",
    description :"Lorem ipsum dolor sit amet consectetur. Ornare massa nunc nibh.",
    iconUrl : clock
  }
]
